import React, { PureComponent } from 'react';

export default class LoadBar extends PureComponent {
	render() {
		return (
			<div className='loading load-bar active'>
				<div className='bar' />
				<div className='bar' />
				<div className='bar' />
			</div>
		);
	}
}